import {
  CLEAR_SETTLEMENTS_WITHOUT_FILTERS,
  CLEAR_SETTLEMENTS_WITH_FILTERS,
  GET_EFFECTIVE_DATES,
  GET_USER_SETTLEMENT_CONTRACTS,
  GET_SETTLEMENTS,
  HIDE_CONFIRM_SETTLE_MODAL,
  SEND_MERCHANT_IBAN,
  SETTLEMENTS_FILTER,
  SHOW_CONFIRM_SETTLE_MODAL,
} from 'redux/actions/types';

const initialState = {
  isLoading: true,
  settlements: null,
  accounts: null,
  walletItems: null,
  settlementStatuses: null,
  walletInfo: [],
};

const settlements = (state = initialState, { type, data }) => {
  switch (type) {
    case GET_SETTLEMENTS:
      return {
        ...state,
        settlements: data.transactions,
        accounts: data.accounts,
        walletItems: data.wallets,
        settlementStatuses: data.settlementStatuses,
        isLoading: false,
      };
    case CLEAR_SETTLEMENTS_WITH_FILTERS:
      return {
        isLoading: true,
      };
    case CLEAR_SETTLEMENTS_WITHOUT_FILTERS:
      return {
        ...initialState,
        filter: state.filter,
      };
    case GET_EFFECTIVE_DATES:
      return {
        ...state,
        walletInfo: data.effectiveDates,
        otherFeeTypes: data.otherFeeTypes,
      };
    case GET_USER_SETTLEMENT_CONTRACTS:
      return {
        ...state,
        userSettlementContract: data,
      };
    case SEND_MERCHANT_IBAN:
      return {
        ...state,
        inquiryAccountInfo: data,
      };
    case SHOW_CONFIRM_SETTLE_MODAL:
      return {
        ...state,
        showConfirmation: true,
        payload: data,
      };
    case HIDE_CONFIRM_SETTLE_MODAL:
      return {
        ...state,
        showConfirmation: false,
      };
    case SETTLEMENTS_FILTER:
      return {
        ...state,
        filter: data,
      };

    default:
      return state;
  }
};

export default settlements;
